import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

function ActiveToolPill({ tool, onClear, className = "" }) {
  const [hover, setHover] = useState(false);
  const Icon = tool?.icon;

  if (!tool) return null;

  return (
    <div
      className={`prompt-holder ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        position: "relative",
        backgroundColor: "#396D87",
        border: "1px solid rgba(57,109,135,0.35)",
        color: "#fff",
      }}
      title={tool.label}
    >
      {Icon ? <Icon style={{ fontSize: 16 }} /> : null}
      {tool.label}

      {hover && (
        <span
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClear?.();
          }}
          onMouseDown={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: -6,
            right: -6,
            width: 18,
            height: 18,
            borderRadius: "50%",
            background: "#fff",
            border: "1px solid #ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          title="Disable"
        >
          <CloseIcon sx={{ fontSize: 12, color: "#396d87" }} />
        </span>
      )}
    </div>
  );
}

export default ActiveToolPill;
